import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
   selector: 'app-card-tabs',
   templateUrl: './card-tabs.component.html',
   styleUrls: [],
   encapsulation: ViewEncapsulation.None
})
export class CardTabsComponent implements OnInit {
   
   constructor() {
   }
   
   ngOnInit() {
   }
}
